import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import ReactPixel from 'react-facebook-pixel';

const Promo = () => {
  const textStyle = {
    fontFamily: 'Poppins',
    fontWeight: 500,
  };

  const redirectToWhatsapp = () => {
    if (process.env.NODE_ENV.trim() === 'production') {
      ReactPixel.track('AddToCart', {
        content_type: 'Phone Case',
      });
      console.log('Facebook Pixel Contact Event Integrated');
    }
    window.open(
      'https://wa.me/6287867661084?text=Halo%20kak%2C%20saya%20mau%20pesan%20case',
    );
  };

  return (
    <section className='primary-bg pb-10 pt-4' style={textStyle}>
      {/* <h2 className="text-center font-bold text-3xl mb-6" style={{fontFamily: 'Poppins'}}>Terbatas!</h2> */}

      <div className='secondary-bg mx-3 p-4 text-center'>
        <h2 className='text-2xl text-red-600 font-bold'>PROMO TERBATAS</h2>
        <div className='text-5xl mt-6'>
          Rp <span className='line-through'>244.000</span>
        </div>
        <div className='text-5xl ml-8 mt-1 text-red-600 font-bold'>149.000</div>
        <div className='mt-4'>(Kamu hemat Rp 95.000,-)</div>
      </div>

      <div className='text-center my-4'>
        <h3 className='text-xl font-bold'>*KHUSUS 9 PEMBELI PERTAMA*</h3>
      </div>

      <div className='secondary-bg p-4'>
        <p className='text-xl text-center'>
          Kamu dapat 1 Pcs Case Premium seharga Rp 195.000
        </p>

        {/* <div className="flex justify-center mt-4">
          <div className="rounded-full text-4xl text-white border-2 border-white px-4 py-2" style={{width: 'fit-content'}}>+</div>
        </div> */}

        <div className='flex justify-center mt-4 text-4xl'>
          <div
            className='bg-red-600 text-white px-6 py-2 rounded-lg'
            style={{ width: 'fit-content' }}>
            PLUS
          </div>
        </div>

        <ul className='mt-5 text-xl'>
          <li>
            <span className='text-red-600 font-bold'>Bonus</span> 25 Pcs
            Polaroid Premium Seharga Rp 49.000
          </li>
          <li>
            <span className='text-red-600 font-bold'>Bonus</span> Konsultasi
            desain
          </li>
          <li>
            <span className='text-red-600 font-bold'>Bonus</span> Gratis ongkir
          </li>
        </ul>
      </div>

      <div className='mt-6 text-center'>
        <button
          onClick={redirectToWhatsapp}
          className='rounded-full primary-color shadow-md secondary-bg py-3 text-xl px-20'>
          <FontAwesomeIcon icon={faThumbsUp} className='mr-3' />
          AMBIL PROMO
        </button>
      </div>
    </section>
  );
};

export default Promo;
